import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer({ settings }) {
  const tel = (settings.phone || "").replace(/\s/g, "");
  return (
    <footer data-testid="site-footer" className="bg-[#10180f] text-cream pt-16 pb-28 md:pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <img src="/logo.png" alt="MARY SERVICES" className="h-14 sm:h-20 w-auto invert" data-testid="footer-logo" />
          <p className="mt-5 font-mono text-xs sm:text-sm uppercase tracking-[0.2em] text-cream/50">
            Entretien • Nettoyage • Espaces verts
          </p>
        </div>

        <div className="mt-14 grid gap-10 sm:grid-cols-2 max-w-2xl">
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-cream/40 mb-4">Contact</h3>
            <ul className="space-y-3 text-cream/80 text-sm">
              <li>
                <a href={`tel:${tel}`} data-testid="footer-phone-link" className="inline-flex items-center gap-2.5 hover:text-cream transition-colors">
                  <Phone className="h-4 w-4 text-terra" /> {settings.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${settings.email}`} data-testid="footer-email-link" className="inline-flex items-center gap-2.5 hover:text-cream transition-colors">
                  <Mail className="h-4 w-4 text-terra" /> {settings.email}
                </a>
              </li>
              <li className="inline-flex items-center gap-2.5">
                <MapPin className="h-4 w-4 text-terra" /> {settings.zone}
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-cream/40 mb-4">Informations</h3>
            <ul className="space-y-3 text-cream/80 text-sm">
              <li><Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-cream transition-colors">Mentions légales</Link></li>
              <li><Link to="/politique-de-confidentialite" data-testid="footer-privacy-link" className="hover:text-cream transition-colors">Politique de confidentialité</Link></li>
              <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-cream transition-colors">Espace pro</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-cream/10 text-center text-xs text-cream/40" data-testid="footer-copyright">
          <p>© {new Date().getFullYear()} MARY SERVICES</p>
        </div>
      </div>
    </footer>
  );
}
